/* import __COLOCATED_TEMPLATE__ from './create-pin.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { action } from '@ember/object';
import { assertInstanceOf } from '@banking/ui/utils/assert';
import { inject as service } from '@ember/service';
// TODO(steckel): Pass in as an argument
const VALID_PIN_INPUT = /^(\s*|\d+)$/;
export let FieldIdentifier = /*#__PURE__*/function (FieldIdentifier) {
  FieldIdentifier["CREATE_PIN"] = "CREATE_PIN";
  FieldIdentifier["CONFIRM_PIN"] = "CONFIRM_PIN";
  return FieldIdentifier;
}({});
let CreatePin = (_class = class CreatePin extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get buttons() {
    return [{
      rank: 'primary',
      disabled: this.args.nextButtonDisabled,
      text: this.intl.t('banking.checking.onboarding.createPin.nextButtonCTA'),
      onClick: this.args.onNextButtonClick
    }];
  }
  get descriptionTranslation() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.createPin.description'));
  }

  // FIXME(steckel): Change any to unknown and type-narrow
  onInputChange(fieldIdentifier, event) {
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    if (!VALID_PIN_INPUT.test(val)) {
      event.preventDefault();
      return;
    }
    switch (fieldIdentifier) {
      case FieldIdentifier.CREATE_PIN:
        this.args.onCreatePinChange(val);
        break;
      case FieldIdentifier.CONFIRM_PIN:
        this.args.onConfirmPinChange(val);
        break;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _class);
export { CreatePin as default };